import React from 'react'
import type { GroupProps } from 'react-select'
import { components } from 'react-select'

import { GroupStyled } from './Group.styles'

const Group = (props: GroupProps) => (
  <GroupStyled>
    <components.Group {...props} />
  </GroupStyled>
)

export default Group
